import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.js";  // ✅ Ensure file extension is present
import "./index.css";
import reportWebVitals from "./reportWebVitals.js";  // ✅ Ensure file extension is present

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
